var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-progress',{attrs:{"animated":_vm.animated,"variant":"success","value":_vm.processedAmount,"max":_vm.maxAmount,"height":"2rem","width":"10rem"}}),_c('div',{staticClass:"progress-text"},[_vm._v(_vm._s(_vm.downloadBarText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }